import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CartPreview" })
export default class CartPreview extends Vue {
    public localizer: any = Localizer;

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    get isCartPreviewShow() {
        return this.$store.getters["cartStore/isCartPreviewShow"];
    }

    @Watch("isCartPreviewShow") onCartPreviewVisibleChanged(value: boolean, oldValue: boolean) {
        if (value) {
            document.documentElement.scrollTop = 0;

            let vue = this;
            setTimeout(function () {
                vue.$store.commit("cartStore/setIsCartPreviewShow", false);
            }, 3000);
        }
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2 }).format(data);
    }
};